'use client';

import React from 'react';
import { useTranslations } from 'next-intl';
import { PageType, useGTM } from '@/features/Analytics';
import { TriggerPhones } from '@/features/Phones/ui/TriggerPhones';
import type { ButtonVariants } from '@/shared/ui/button';
import type { IMedcenterDetails } from '@/entities/medcenter/model/types';
interface Props {
  medcenter: IMedcenterDetails;
  btnVariants?: ButtonVariants;
  isIcon?: boolean;
  hasOnline?: boolean;
}
export const MedcenterPhonesButtons: React.FC<Props> = ({
  btnVariants,
  isIcon = false,
  hasOnline = false,
  medcenter
}) => {
  const t = useTranslations();
  const {
    trackEvent
  } = useGTM(PageType.MEDCENTER_PROFILE);
  const handleShowPhones = () => {
    trackEvent('click_show_clinic_number', {
      medcenterName: medcenter.fullName
    });
  };
  return <>
      {medcenter.hasPhones && <TriggerPhones isIcon={isIcon} medcenterId={medcenter.id} onShowPhonesGtmEvent={handleShowPhones} btnVariants={btnVariants} hasOnline={hasOnline} isFull btnText={isIcon && hasOnline ? '' : t('bookingPage.show_phone')} />}
    </>;
};